
<div class="w-100">
  <div class="float-left">{{'front.demandeProlongation.nbMois' | translate}} : {{demandeProlongation.nbMois}}</div>
  @if (demandeProlongation.fichier) {
    <div class="button-download float-right">
      <mat-icon>download</mat-icon>
      <a (click)="toolService.download(demandeProlongation.fichier)" href="javascript:void(0);">
        {{'mesCandidatures.candidature.telechargeDocument' | translate}}
      </a>
    </div>
  }
</div>
<div class="clearfix"></div>
<p class="content-justification">{{demandeProlongation.justification}}</p>

@if (demandeProlongation.informationFinance && isAdmin) {
  <div class="mt-1 mb-1">
    @if(demandeProlongation.dateInformationFinance){
      {{demandeProlongation.dateInformationFinance | date:dateShort}} -
    }
    {{'front.demandeProlongation.informationFinance' | translate }} :
    <p class="content-justification">
      {{demandeProlongation.informationFinance}}
    </p>
  </div>
}
<div class="w-100">
  @if (demandeProlongation.dateDecisionAdmin) {
    <div class="float-left">
      {{demandeProlongation.dateDecisionAdmin | date:dateShort}} - {{'front.demandeProlongation.justificationAdmin' | translate }}
    </div>
  }
  @if (demandeProlongation.courrierAcceptation) {
    <div class="button-download float-right">
      <mat-icon>download</mat-icon>
      <a (click)="toolService.download(demandeProlongation.courrierAcceptation)" href="javascript:void(0);">
        {{'mesCandidatures.candidature.telechargeDocument' | translate}}
      </a>
    </div>
  }
</div>
<div class="clearfix"></div>
@if (demandeProlongation.justificationAdmin) {
  <p class="content-justification">
    {{demandeProlongation.justificationAdmin}}
  </p>
}
